import { initGlobals } from './global.js';
import { registerSidebar } from './components/sidebar.js';
import { registerToast } from './components/toast.js';
import { registerDashboard } from './components/dashboard.js';
import { registerChannelsSmm } from './components/channels-smm.js';
import { registerAgents } from './components/agents.js';
import { registerChannelsSeo, initWebmasterBind } from './components/channels-seo.js';
import { registerAuthMax } from './components/auth-max.js';
import { initAuthRegister } from './components/auth-register.js';
import { initSeoRecommended } from './components/seo-recommended.js';
import { initSeoPositions } from './components/seo-positions.js';
import { initSettings } from './components/settings.js';
import { initAdminCharts } from './components/admin-charts.js';

initGlobals();

document.addEventListener('alpine:init', () => {
    registerSidebar();
    registerToast();
    registerDashboard();
    registerChannelsSmm();
    registerAgents();
    registerChannelsSeo();
    registerAuthMax();
});

initAuthRegister();
initSeoRecommended();
initSeoPositions();
initSettings();
initAdminCharts();
initWebmasterBind();
